/* eslint-disable no-else-return */
/* eslint-disable import/no-cycle */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable max-lines */
import moment from 'moment';
import { useContext } from 'react';
import { Box, Typography } from '@mui/material';

import AES from 'crypto-js/aes';
import CryptoJS from 'crypto-js';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import './OtpLogin/ReceiveCode.css';
import CheckBoxTick from '../images/checkBox-tick.svg';
import {
  MANDATORY_FIELD_ERR,
  HOMEUS_PR,
  HOME_PR,
  HOME_VI,
  HOME_USA,
  HOMEUS_VI,
  SELF_EMPLOYED,
  EMPLOYED,
  INVALID_FORMAT_ERR,
  INVALID_DATE,
  PROGRESA_CONTIGO,
  ELITE_ACCOUNT_EN,
  PRODUCT_PERSONAL,
  SALES,
  LIBRE_AHORRA_BUNDLE,
  INVALID_FORMAT_ERR_BUNDLE,
  DOB_DAY,
  CD_IRA,
  PRODUCT_IRAEDUCATION,
  PRODUCT_ABC,
  BENEFICIARY_SSN,
  ALLOWED_LOCATIONS,
  ALLOWED_LANGUAGES,
  BANK_BASE_URL,
  FALLBACK_URL,
  ORIENTAL_SHAREPOINT_URL,
} from '../constants';

import { businessMapping } from '../services/businessMapping';
import { fetchVouchedAddress, getAddressLookupData } from '../services/formService';
import { productMapping } from '../services/productMapping';
import { saveKnockOffData } from './DGI/CommonFunctions';
import { addAutoCompleteCityToDropdownIfMissing } from './DGI/DGIAccountInfoUtils';
import { dgiMapping } from '../services/dgiMapping';
import { productNameURLMapping } from '../services/productNameURLMapping';
import { dgiContMapping } from '../services/dgiContMapping';
import CommonDataContext from '../WebComponents/context/CommonDataContext';
import LeadGenerationContext from '../context/LeadGenerationContext';
import { getEmailVerificationData } from '../services/validationService';

export const commonTernary = (condition, result1, result2) => {
  if (condition) {
    return result1;
  }
  return result2;
};
export const isWebComponentFlow = () => {
  const commonDataContext = useContext(CommonDataContext);
  const leadGenerationContext = useContext(LeadGenerationContext);

  return commonDataContext?.wcFlow && commonDataContext !== undefined
    ? commonDataContext
    : leadGenerationContext;
};

export const commonFunction = (value) => {
  if (value) {
    return value;
  }
  return null;
};
export const zipCodeValueSetError = (zipcode) => {
  if (zipcode?.match(/^0+$/g)) {
    return '* Please enter a valid zipcode';
  }
  return '';
};

export const handleETBFlow = (leadGenerationContext, history, nextPage) => {
  if (
    leadGenerationContext.customerType === 'ETB' &&
    leadGenerationContext.flowTypeETB === 'EtbFlow'
  ) {
    if (leadGenerationContext?.wcFlow) {
      history.push(nextPage);
    } else {
      history.push(
        `/${leadGenerationContext.location?.toLowerCase()}/${leadGenerationContext.language?.toLowerCase()}/express/retail-form/${productNameURLMapping(
          leadGenerationContext.productName
        )}/${nextPage}`
      );
    }
  }
};
export const isEtbFlow = (leadGenerationContext) =>
  (leadGenerationContext.customerType === 'ETB' &&
    leadGenerationContext.flowTypeETB === 'EtbFlow') ||
  false;

function areAllNumbersSameInPhoneNumber(phoneWithHyphens, leadGenerationContext) {
  let newPhoneNumber;
  const phoneWithoutHyphens = phoneWithHyphens?.replace(/[-() ]/g, '');
  if (phoneWithoutHyphens.length === 7 && leadGenerationContext.location !== 'VI') {
    newPhoneNumber = phoneWithoutHyphens;
  } else if (phoneWithoutHyphens.length === 10 && leadGenerationContext.location === 'VI') {
    newPhoneNumber = phoneWithoutHyphens.substring(3);
  }
  if (newPhoneNumber && newPhoneNumber.length === 7) {
    const numbersArray = Array.from(newPhoneNumber);
    const firstNumber = numbersArray[0];
    return numbersArray.every((number) => number === firstNumber);
  }
  return false;
}

export const checkInvalidMobileNumber = (phoneNumber, leadGenerationContext) => {
  const result = areAllNumbersSameInPhoneNumber(phoneNumber, leadGenerationContext);
  return result;
};

export const autoCompleteOccupation = (name, value, leadGenerationContext) => {
  leadGenerationContext.setIsScreenFourDirty(true);
  leadGenerationContext.setIsScreenFiveDirty(true);
  leadGenerationContext.setIsBeneficiaryScreenDirty(true);
  leadGenerationContext.setIsFeatureScreenDirty(true);
  leadGenerationContext.setIsFundingScreenDirty(true);
  leadGenerationContext.setEmploymentInformation({
    ...leadGenerationContext.employmentInformation,
    [name]: value,
  });
  if (value === null) {
    leadGenerationContext.setEmploymentInformationErrors({
      ...leadGenerationContext.employmentInformationErrors,
      [name]: '* Mandatory Field',
    });
  } else {
    leadGenerationContext.setEmploymentInformationErrors({
      ...leadGenerationContext.employmentInformationErrors,
      [name]: '',
    });
  }
};

export const autoCompleteCommon = (name, value, leadGenerationContext) => {
  leadGenerationContext.setIsTrustInfoDirty(true);
  leadGenerationContext.setIsFinanceInfoDirty(true);
  leadGenerationContext.setIsFundingScreenDirty(true);
  leadGenerationContext.setIsEdeliveryScreenDirty(true);

  leadGenerationContext.setDgiEmploymentStatus({
    ...leadGenerationContext.dgiEmploymentStatus,
    [name]: value,
  });
  if (value === null) {
    leadGenerationContext.setDgiEmploymentStatusErrors({
      ...leadGenerationContext.dgiEmploymentStatusErrors,
      [name]: MANDATORY_FIELD_ERR,
    });
  } else {
    leadGenerationContext.setDgiEmploymentStatusErrors({
      ...leadGenerationContext.dgiEmploymentStatusErrors,
      [name]: '',
    });
  }
};
export const handleCurrency = (curr) => {
  const currencyValue = curr?.replace(/^0+/, '');
  const newCurrencyValue = nbrToCurrencyFormat(currencyValue);
  const newDeposit = `${'$'}${newCurrencyValue}${'.00'}`;
  return newDeposit;
};
export const autoCompleteCommonCommercial = (name, value, leadGenerationContext) => {
  leadGenerationContext.setIsBusinessAdditionalInfoDirty(true);
  leadGenerationContext.setIsBusinessSuriDirty(true);
  leadGenerationContext.setIsBusinessCompDirty(true);
  leadGenerationContext.setIsBusinessAccountInfoDirty(true);
  leadGenerationContext.setIsDocChecklistDirty(true);
  leadGenerationContext.setIsCommercialProductUIDirty(true);

  leadGenerationContext.setBusinessAdditionalInfo({
    ...leadGenerationContext.businessAdditionalInfo,
    [name]: value,
  });
  if (value === null) {
    leadGenerationContext.setBusinessAdditionalInfoErrors({
      ...leadGenerationContext.businessAdditionalInfoErrors,
      [name]: MANDATORY_FIELD_ERR,
    });
  } else {
    leadGenerationContext.setBusinessAdditionalInfoErrors({
      ...leadGenerationContext.businessAdditionalInfoErrors,
      [name]: '',
    });
  }
};
export const autoCompleteConCommon = (name, value, leadGenerationContext) => {
  leadGenerationContext.setConEmploymentStatus({
    ...leadGenerationContext.conEmploymentStatus,
    [name]: value,
  });
  if (value === null) {
    leadGenerationContext.setConEmploymentStatusError({
      ...leadGenerationContext.conEmploymentStatusError,
      [name]: MANDATORY_FIELD_ERR,
    });
  } else {
    leadGenerationContext.setConEmploymentStatusError({
      ...leadGenerationContext.conEmploymentStatusError,
      [name]: '',
    });
  }
};

export const empStatusAsEmpSelfEmp = (addressObject, leadGenerationContext) => {
  const { dgiEmploymentStatus } = leadGenerationContext;
  if (
    dgiEmploymentStatus.empStatus === SELF_EMPLOYED ||
    dgiEmploymentStatus.empStatus === EMPLOYED
  ) {
    leadGenerationContext.setIsTrustInfoDirty(true);
    leadGenerationContext.setIsFinanceInfoDirty(true);
    leadGenerationContext.setIsFundingScreenDirty(true);
    leadGenerationContext.setIsEdeliveryScreenDirty(true);
  } else if (leadGenerationContext.isCheckedTrustContact === true) {
    leadGenerationContext.setIsTrustInfoDirty(true);
    leadGenerationContext.setIsFinanceInfoDirty(true);
    leadGenerationContext.setIsFundingScreenDirty(true);
  }
};
const handleAddressInfo = (addressObject) => {
  let contryVal;
  if (addressObject?.Address?.CountrySubdivisionCode === HOMEUS_PR) {
    contryVal = HOME_PR;
  } else if (addressObject?.Address?.CountrySubdivisionCode === HOMEUS_VI) {
    contryVal = HOME_VI;
  } else {
    contryVal = HOME_USA;
  }
  return contryVal;
};
export const addressAutocomplete = (addressObject, leadGenerationContext) => {
  const { dgiEmploymentStatus, dgiEmploymentStatusErrors } = leadGenerationContext;

  empStatusAsEmpSelfEmp(addressObject, leadGenerationContext);

  let city = '';
  let state = '';
  let country = '';
  let zipCode = '';
  let address1 = '';
  if (
    addressObject?.Address?.AddressLine1 ||
    addressObject?.Address?.PostalCode ||
    addressObject?.Address?.City
  ) {
    address1 = addressObject?.Address?.AddressLine1?.trim() || '';
    zipCode = addressObject?.Address?.PostalCode.split('-')[0];
    city = addressObject?.Address?.City;
  }
  country = handleAddressInfo(addressObject);

  if (
    (addressObject?.Address?.State && country === HOME_VI) ||
    (addressObject?.Address?.State && country === HOME_PR)
  ) {
    state = 'N/A';
  } else {
    state = addressObject?.Address?.State;
  }

  const cityPresent = addAutoCompleteCityToDropdownIfMissing(country, state, city);

  if (
    dgiEmploymentStatus.empStatus === SELF_EMPLOYED ||
    dgiEmploymentStatus.empStatus === EMPLOYED
  ) {
    if (!cityPresent) {
      leadGenerationContext.setDgiEmploymentStatus({
        ...dgiEmploymentStatus,
        missingAutoCompleteCity: city,
      });
    }
    leadGenerationContext.setDgiEmploymentStatus({
      ...dgiEmploymentStatus,
      address1,
      city,
      country,
      state,
      zipCode,
    });
    leadGenerationContext.setDgiEmploymentStatusErrors({
      ...dgiEmploymentStatusErrors,
      address1: '',
      city: '',
      country: '',
      state: '',
      zipCode: zipCodeValueSetError(zipCode),
    });
  }
};
export const addressAutocompleteTrusted = (addressObject, leadGenerationContext) => {
  let city = '';
  let state = '';
  let country = '';
  let zipCode = '';
  let address1 = '';
  if (
    addressObject?.Address?.AddressLine1 ||
    addressObject?.Address?.PostalCode ||
    addressObject?.Address?.City
  ) {
    address1 = addressObject?.Address?.AddressLine1?.trim() || '';
    zipCode = addressObject?.Address?.PostalCode.split('-')[0];
    city = addressObject?.Address?.City;
  }
  country = handleAddressInfo(addressObject);

  if (
    (addressObject?.Address?.State && country === HOME_VI) ||
    (addressObject?.Address?.State && country === HOME_PR)
  ) {
    state = 'N/A';
  } else {
    state = addressObject?.Address?.State;
  }

  const cityPresent = addAutoCompleteCityToDropdownIfMissing(country, state, city);

  if (leadGenerationContext.isCheckedTrustContact === true) {
    if (!cityPresent) {
      leadGenerationContext.setTrustedContactInformation((prevState) => ({
        ...prevState,
        missingAutoCompleteCity: city,
      }));
    }

    leadGenerationContext.setTrustedContactInformation((prevState) => ({
      ...prevState,
      address1,
      city,
      country,
      state,
      zipCode,
    }));
    leadGenerationContext.setTrustedContactInformationErrors((prevState) => ({
      ...prevState,
      address1: '',
      city: '',
      country: '',
      state: '',
      zipCode: zipCodeValueSetError(zipCode),
    }));
  }
};

export async function fetchAddressLookup(
  address1,
  country,
  query,
  accessToken,
  setAddressLookupData,
  setAddressLookupDataResponse,
  setCallLookupApi,
  setCallLookupApiHome,
  setCallLookupApiEmp,
  setCallLookupApiHomeSelfEmp,
  baseContext,
  otherData = {}
) {
  const { checkNonUSAddress } = otherData;
  if (address1?.length >= 6) {
    const response = await getAddressLookupData(
      country,
      query,
      accessToken,
      setCallLookupApi,
      setCallLookupApiHome,
      setCallLookupApiEmp,
      setCallLookupApiHomeSelfEmp,
      baseContext?.initiateUiResponse,
      { isWCFlow: baseContext?.wcFlow, env: baseContext?.environment }
    );
    if (response?.data?.Results) {
      const nonUSOptions = extractNonUSLocations(response.data.Results);
      const options = [];
      response.data.Results.forEach((result) => {
        const address = result.Address;
        const zipCode = address.PostalCode.split('-')[0];
        options.push(`${address.AddressLine1}, ${address.City}, ${address.State}, ${zipCode}`);
      });
      const opt = checkNonUSAddress ? nonUSOptions : options;
      setAddressLookupData(opt);
    }
    setAddressLookupDataResponse(response);
  }
}
export const commonBusinessContactChange = (name, value, leadGenerationContext, reg) => {
  const {
    setBusinessContactInformation,
    setBusinessContactInformationErrors,
    setSaveAppContactInfo,
    setSaveAppContactInfoErrors,
  } = leadGenerationContext;
  const valueForValidation = value.trim();
  if (valueForValidation.match(reg)) {
    setBusinessContactInformation((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setBusinessContactInformationErrors((prevState) => ({
      ...prevState,
      [name]: '',
    }));
    if (name === 'lastName') {
      setSaveAppContactInfo((prevState) => ({
        ...prevState,
        lastName: value,
      }));
      setSaveAppContactInfoErrors((prevState) => ({ ...prevState, lastName: '' }));
    }
  } else if (valueForValidation === '') {
    setBusinessContactInformation((prevState) => ({ ...prevState, [name]: '' }));
    setBusinessContactInformationErrors((prevState) => ({
      ...prevState,
      [name]: '* Mandatory Field',
    }));
  } else {
    setBusinessContactInformation((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setBusinessContactInformationErrors((prevState) => ({
      ...prevState,
      [name]: '* Invalid Format',
    }));
  }
};

export const contactNameChange = (name, value, leadGenerationContext, regex) => {
  const { setContactInformation, setContactInformationErrors, productName } = leadGenerationContext;

  const valueForValidation = value.replace(/\s+$/, '');
  const isTrailingSpace = value.endsWith(' ');

  setContactInformation((prev) => ({
    ...prev,
    [name]: value,
  }));

  if (value === '') {
    setContactInformationErrors((prev) => ({
      ...prev,
      [name]: MANDATORY_FIELD_ERR,
    }));
    return;
  }

  if (regex.test(valueForValidation)) {
    setContactInformationErrors((prev) => ({
      ...prev,
      [name]: '',
    }));
    return;
  }

  if (!isTrailingSpace) {
    setContactInformationErrors((prev) => ({
      ...prev,
      [name]:
        productMapping(productName) === LIBRE_AHORRA_BUNDLE
          ? INVALID_FORMAT_ERR_BUNDLE
          : INVALID_FORMAT_ERR,
    }));
  }
};

export const handleTrimmedBlur = (e, handleChange, extraBlurAction) => {
  if (!e || !e.target || typeof handleChange !== 'function') return;

  const { name, value } = e.target;
  const trimmedValue = typeof value === 'string' ? value.trim() : value;

  handleChange({
    ...e,
    target: {
      ...e.target,
      name,
      value: trimmedValue,
    },
  });

  // Optional extra blur behavior
  if (typeof extraBlurAction === 'function') {
    extraBlurAction();
  }
};

export const handleDGIAdditionalInfoDirty = (context) => {
  context.setIsTrustInfoDirty(true);
  context.setIsFinanceInfoDirty(true);
  context.setIsFundingScreenDirty(true);
  context.setIsEdeliveryScreenDirty(true);
};

export const handleComplianceDirty = (context) => {
  context.setIsScreenFourDirty(true);
  context.setIsScreenFiveDirty(true);
  context.setIsBeneficiaryScreenDirty(true);
  context.setIsFeatureScreenDirty(true);
  context.setIsFundingScreenDirty(true);
};

export const handleComplianceChange = (e, setChange, setError, setDirtyFlag, invalidErrorMSG) => {
  setDirtyFlag();
  const { name, value } = e.target;
  const normalizedValue = value.replace(/^\s+/, '');
  const valueForValidation = value.trim();
  const validationRegex = /^[A-Za-z0-9@&_.\-\s,()]*$/;

  setChange((prevState) => ({
    ...prevState,
    [name]: normalizedValue,
  }));

  if (typeof value === 'string' && value.startsWith(' ')) {
    setError((prevState) => ({
      ...prevState,
      [name]: INVALID_FORMAT_ERR,
    }));
    return;
  }
  if (valueForValidation === '') {
    setError((prevState) => ({
      ...prevState,
      [name]: MANDATORY_FIELD_ERR,
    }));
    return;
  }
  if (valueForValidation.length >= 2 && validationRegex.test(valueForValidation)) {
    setError((prevState) => ({
      ...prevState,
      [name]: '',
    }));
    return;
  }
  setError((prevState) => ({
    ...prevState,
    [name]: invalidErrorMSG,
  }));
};

export const nameChange = (e, leadGenerationContext, setState, setStateError, regex) => {
  const { productName } = leadGenerationContext;
  if (e.target.value.match(regex)) {
    setState((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    setStateError((prevState) => ({ ...prevState, [e.target.name]: '' }));
  } else if (e.target.value === '') {
    setState((prevState) => ({ ...prevState, [e.target.name]: '' }));
    setStateError((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
    }));
  } else {
    setState((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    setStateError((prevState) => ({
      ...prevState,
      [e.target.name]:
        productMapping(productName) === LIBRE_AHORRA_BUNDLE
          ? INVALID_FORMAT_ERR_BUNDLE
          : INVALID_FORMAT_ERR,
    }));
  }
};

export const saveAppcontactNameChange = (e, leadGenerationContext, regex) => {
  const {
    setSaveAppContactInfo,
    setSaveAppContactInfoErrors,
    setPersonalInformation,
    setPersonalInformationErrors,
    setContactInformation,
    setContactInformationErrors,
    setBusinessContactInformation,
    setBusinessContactInformationErrors,
    productName,
  } = leadGenerationContext;
  const valueWithoutLeadingSpace = e.target.value.replace(/^\s+/, '');
  const valueForValidation = e.target.value.trim();
  if (valueForValidation.match(regex)) {
    setSaveAppContactInfo((prevState) => ({
      ...prevState,
      [e.target.name]: valueWithoutLeadingSpace,
    }));
    setSaveAppContactInfoErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));

    setBusinessContactInformation((prevState) => ({
      ...prevState,
      [e.target.name]: valueWithoutLeadingSpace,
    }));
    setBusinessContactInformationErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));

    setPersonalInformation((prevState) => ({
      ...prevState,
      [e.target.name]: valueWithoutLeadingSpace,
    }));
    setPersonalInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
    setContactInformation((prevState) => ({
      ...prevState,
      [e.target.name]: valueWithoutLeadingSpace,
    }));
    setContactInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
  } else if (valueForValidation === '') {
    setSaveAppContactInfo((prevState) => ({ ...prevState, [e.target.name]: '' }));
    setSaveAppContactInfoErrors((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
    }));

    setBusinessContactInformation((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
    setBusinessContactInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
    }));

    setPersonalInformation((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
    setPersonalInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
    }));

    setContactInformation((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
    setContactInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
    }));
  } else {
    setSaveAppContactInfo((prevState) => ({
      ...prevState,
      [e.target.name]: valueWithoutLeadingSpace,
    }));
    setSaveAppContactInfoErrors((prevState) => ({
      ...prevState,

      [e.target.name]:
        productMapping(productName) === LIBRE_AHORRA_BUNDLE
          ? INVALID_FORMAT_ERR_BUNDLE
          : INVALID_FORMAT_ERR,
    }));
  }
};
const timeOutFunc = (selectionStart, numkeys, e) => {
  setTimeout(() => {
    const input = getRoot().getElementById('dgiAccountNumber');
    if (input?.setSelectionRange) {
      if (selectionStart + 1 === 4 && e.target.value.charAt(selectionStart - 1).includes(numkeys)) {
        input.setSelectionRange(selectionStart + 2, selectionStart + 2);
      } else if (selectionStart !== 4) {
        input.setSelectionRange(selectionStart, selectionStart);
      } else if (selectionStart === 4) {
        e.target.selectionEnd = selectionStart + 1;
      }
    }
  }, 10);
};
export const changeDgiAccNumberAndroid = (e, leadGenerationContext) => {
  const { setIsFundingScreenDirty, setFundData, setFundDataErrors, fundDataErrors, fundData } =
    leadGenerationContext;
  setIsFundingScreenDirty(true);
  const { selectionStart } = e.target;
  const alpha1 = Array.from(Array(26)).map((_e, i) => i + 65);
  const alphabet = alpha1.map((x) => String.fromCharCode(x));
  const smallAlpha = Array.from(Array(26)).map((_e, i) => i + 97);
  const smallAlphabet = smallAlpha.map((x) => String.fromCharCode(x));
  const nums = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  const numkeys = [...nums, ...alphabet, ...smallAlphabet];

  let ssnValue = e.target.value;
  ssnValue = ssnValue.replace(/[^a-zA-Z0-9]/g, '');
  ssnValue = ssnValue.replace('-', '');
  if (e.target.value.length <= 10) {
    if (ssnValue?.toString().length >= 4) {
      ssnValue = `${ssnValue.slice(0, 3)}-${ssnValue.slice(3, ssnValue.toString().length)}`;
    }
    const alpha = ssnValue.slice(0, 3);
    if (alpha.match(/[N|n][E|e][E|c|e|C]/)) {
      setFundDataErrors({
        ...fundDataErrors,
        [e.target.name]: '',
      });
    } else {
      setFundDataErrors({
        ...fundDataErrors,
        [e.target.name]: '* Please enter a valid DGI account number',
      });
    }
    const num = ssnValue.slice(4, ssnValue.toString().length);
    if (!(num.match(/^\d+$/) && num.length === 6)) {
      setFundDataErrors({
        ...fundDataErrors,
        [e.target.name]: '* Please enter a valid DGI account number',
      });
    }
    timeOutFunc(selectionStart, numkeys, e);

    if (ssnValue === '') {
      setFundDataErrors({
        ...fundDataErrors,
        [e.target.name]: '* Mandatory Field',
      });
    }
    setFundData({ ...fundData, [e.target.name]: ssnValue });
  }
};

export const addressLineCheck = (address) => {
  let addrVal;
  if (address) {
    if (address.length <= 30) {
      addrVal = address;
    } else {
      addrVal = address.slice(0, 30);
    }
  } else {
    addrVal = '';
  }
  return addrVal;
};
export const clearOCRdata = (leadGenerationContext) => {
  const {
    setAddressProofUploadStatus,
    setAddressInformation,
    setAddressInformationErrors,
    addressInformation,
  } = leadGenerationContext;
  setAddressProofUploadStatus(null);
  setAddressInformation((prevState) => ({
    ...prevState,
    address1: '',
    address2: '',
    state: '',
    country: '',
    city: '',
    zipCode: '',
    vouchedAddrEdited: true,
  }));
  setAddressInformationErrors((prevState) => ({
    ...prevState,
    address2: '',
  }));
  if (addressInformation?.sameMailingAddress) {
    setAddressInformation((prevState) => ({
      ...prevState,
      permanentAddress1: '',
      permanentAddress2: '',
      permanentState: '',
      permanentCountry: '',
      permanentCity: '',
      permanentZipCode: '',
    }));
  }
};
export const handleAddressEditModal = (leadGenerationContext) => {
  const { setAddressEditQuestionModal, popupModalIntial } = leadGenerationContext;

  if (popupModalIntial) {
    setAddressEditQuestionModal(true);
  } else setAddressEditQuestionModal(false);
};

export const emailChange = (e, leadGenerationContext) => {
  const {
    setSaveAppContactInfo,
    setSaveAppContactInfoErrors,
    setPersonalInformation,
    setPersonalInformationErrors,
    setBusinessContactInformation,
    setBusinessContactInformationErrors,
    productName,
  } = leadGenerationContext;
  if (
    e.target.value.match(
      /^([a-zA-Z0-9_.-]+)@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|\d{1,3})(\]?)$/
    )
  ) {
    const emailFirstPart = e.target.value.split('@');
    if (
      emailFirstPart[0].charAt(0) !== '.' &&
      emailFirstPart[0].charAt(0) !== '-' &&
      emailFirstPart[0].charAt(emailFirstPart[0].length - 1) !== '-' &&
      emailFirstPart[0].charAt(emailFirstPart[0].length - 1) !== '.' &&
      !e.target.value.match(/[.\-_]{2,}/)
    ) {
      setPersonalInformation((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setSaveAppContactInfo((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setSaveAppContactInfoErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
      setBusinessContactInformation((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setBusinessContactInformationErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
      setPersonalInformationErrors((prevState) => ({ ...prevState, [e.target.name]: '' }));
    } else {
      setPersonalInformation((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setPersonalInformationErrors((prevState) => ({
        ...prevState,

        [e.target.name]:
          productMapping(productName) === LIBRE_AHORRA_BUNDLE
            ? INVALID_FORMAT_ERR_BUNDLE
            : INVALID_FORMAT_ERR,
      }));
      setSaveAppContactInfo((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setSaveAppContactInfoErrors((prevState) => ({
        ...prevState,

        [e.target.name]:
          productMapping(productName) === LIBRE_AHORRA_BUNDLE
            ? INVALID_FORMAT_ERR_BUNDLE
            : INVALID_FORMAT_ERR,
      }));
    }
  } else if (e.target.value === '') {
    setPersonalInformation((prevState) => ({ ...prevState, [e.target.name]: '' }));
    setPersonalInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
    }));
    setSaveAppContactInfo((prevState) => ({ ...prevState, [e.target.name]: '' }));
    setSaveAppContactInfoErrors((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
    }));
  } else {
    setPersonalInformation((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
    setPersonalInformationErrors((prevState) => ({
      ...prevState,

      [e.target.name]:
        productMapping(productName) === LIBRE_AHORRA_BUNDLE
          ? INVALID_FORMAT_ERR_BUNDLE
          : INVALID_FORMAT_ERR,
    }));
    setSaveAppContactInfo((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
    setSaveAppContactInfoErrors((prevState) => ({
      ...prevState,

      [e.target.name]:
        productMapping(productName) === LIBRE_AHORRA_BUNDLE
          ? INVALID_FORMAT_ERR_BUNDLE
          : INVALID_FORMAT_ERR,
    }));
  }
};
let dummyData = [];
const personalInfoDobChange = (personalInformation, saveAppContactInfo) => {
  if (personalInformation?.dob !== '') {
    if (personalInformation?.dob !== saveAppContactInfo?.dob) {
      if (!dummyData.includes('date of birth')) {
        dummyData.push('date of birth');
      }
    } else if (dummyData.includes('date of birth')) {
      const index = dummyData.indexOf('date of birth');
      dummyData.splice(index, 1);
    }
  }
};
export const handleCheckValuesSaveConti = (leadGenCont) => {
  const { personalInformation, saveAppContactInfo, vouchLastName } = leadGenCont;
  dummyData = [...leadGenCont.saveLaterVal];
  personalInfoDobChange(personalInformation, saveAppContactInfo);
  if (vouchLastName !== '') {
    if (vouchLastName !== saveAppContactInfo?.lastName) {
      if (!dummyData.includes('last name')) {
        dummyData.push('last name');
      }
    } else if (dummyData.includes('last name')) {
      const index = dummyData.indexOf('last name');
      dummyData.splice(index, 1);
    }
  }
  if (personalInformation?.ssn !== '') {
    if (personalInformation?.ssn !== saveAppContactInfo?.ssn) {
      if (!dummyData.includes('ssn')) {
        dummyData.push('ssn');
      }
    } else if (dummyData.includes('ssn')) {
      const index = dummyData.indexOf('ssn');
      dummyData.splice(index, 1);
    }
  }

  return dummyData;
};

/**
 * Handle Save Application button: Should be navigated to Save Application Page */
export const handleSaveApplication = (e, leadGenerationContext) => {
  const { setIsModalSaveLater } = leadGenerationContext;
  e.preventDefault();
  setIsModalSaveLater(true);
};
export const clearUploadFocus = () => {
  let element = '';
  element = getRoot().getElementById('uploadContainer');
  if (element) {
    if (isBundle) {
      element?.setAttribute(
        'style',
        'background-image: repeating-linear-gradient(0deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(90deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(180deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(270deg,#808285,#808285 7px,transparent 8px,transparent 15px) !important; background-size: 1.5px 100%, 100% 1.5px, 1.5px 100%, 100% 1.5px;background-repeat: no-repeat;background-position: 0 0, 0 0, 100% 0, 0 100%'
      );
    } else {
      element?.setAttribute(
        'style',
        'background-image: repeating-linear-gradient(0deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(90deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(180deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(270deg,#808285,#808285 7px,transparent 8px,transparent 15px) !important; background:#F4F4F4;background-size: 1px 100%, 100% 1px, 1px 100%, 100% 1px;background-repeat: no-repeat;background-position: 0 0, 0 0, 100% 0, 0 100%'
      );
    }
  }
};
export const getLang = (language, toLowerCase = false) => {
  let lang = 'En';
  if (language === 'ES') {
    lang = 'Es';
  }

  if (toLowerCase) return lang.toLowerCase();

  return lang;
};
export const nameProduct = (data) => {
  let setProduct;
  if (dgiMapping(data.productName)) {
    setProduct = dgiMapping(data.productName);
  } else if (dgiContMapping(data.productName)) {
    setProduct = dgiContMapping(data.productName);
  } else {
    setProduct = productMapping(data.productName);
  }
  return setProduct;
};
export const handleDOBchange = (newValue, leadGenerationContext) => {
  const {
    setPersonalInformation,
    personalInformation,
    setPersonalInformationErrors,
    personalInformationErrors,
    setBusinessAccountInfo,
    setBusinessAccountInfoError,
    businessAccountInfo,
    businessAccountInfoError,
    productName,
    setIsScreenTwoDirty,
  } = leadGenerationContext;

  if (isBundle(productName)) {
    setIsScreenTwoDirty(true);
  }

  if (businessMapping(productName)) {
    leadGenerationContext.setIsBusinessAccountInfoDirty(true);
    leadGenerationContext.setIsDocChecklistDirty(true);
    leadGenerationContext.setIsCommercialProductUIDirty(true);
    if (newValue) {
      const selectedDate = new Date(newValue);
      const currentdate = new Date();
      const formattedDate = moment(newValue).format('yyyy-MM-DD');

      setBusinessAccountInfo({ ...businessAccountInfo, dob: formattedDate });
      if (newValue == 'Invalid Date') {
        setBusinessAccountInfo({ ...businessAccountInfo, dob: formattedDate });
        setBusinessAccountInfoError({
          ...businessAccountInfoError,
          dob: INVALID_DATE,
        });
      } else if (selectedDate.getTime() > currentdate.getTime()) {
        setBusinessAccountInfoError({
          ...businessAccountInfoError,
          dob: INVALID_DATE,
        });
      } else {
        setBusinessAccountInfoError({ ...businessAccountInfoError, dob: '' });
      }
    } else {
      setBusinessAccountInfo({ ...businessAccountInfo, dob: '' });
      setBusinessAccountInfoError({
        ...businessAccountInfoError,
        dob: '* Mandatory Field',
      });
    }
  } else if (productMapping(productName) || dgiMapping(productName)) {
    if (newValue) {
      const selectedDate = new Date(newValue);
      const currentdate = new Date();
      const formattedDate = moment(newValue).format('yyyy-MM-DD');
      setPersonalInformation({ ...personalInformation, dob: formattedDate });
      if (newValue == 'Invalid Date') {
        setPersonalInformation({ ...personalInformation, dob: formattedDate });
        setPersonalInformationErrors({
          ...personalInformationErrors,
          dob: INVALID_DATE,
        });
      } else if (selectedDate.getTime() > currentdate.getTime()) {
        setPersonalInformationErrors({
          ...personalInformationErrors,
          dob: INVALID_DATE,
        });
      } else {
        setPersonalInformationErrors({ ...personalInformationErrors, dob: '' });
      }
    } else {
      setPersonalInformation({ ...personalInformation, dob: '' });
      setPersonalInformationErrors({
        ...personalInformationErrors,
        dob: MANDATORY_FIELD_ERR,
      });
    }
  }
};

export const getNameInUpperCase = (name) => {
  if (name?.includes(' ')) {
    const words = name.toLowerCase().split(' ');
    return words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};
function cryptoRandom(len) {
  const uuid = uuidv4().replace(/-/g, '');
  return uuid.slice(0, len);
}
export const generateKey = () => cryptoRandom(32);

export const encryptData = (str, code) => {
  const prefix = cryptoRandom(16);
  const iv = CryptoJS.enc.Utf8.parse(code.substring(0, 16));
  const key = CryptoJS.enc.Utf8.parse(code);

  return AES.encrypt(prefix + str, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
};

export const decryptData = (str, code) => {
  const iv = CryptoJS.enc.Utf8.parse(code.substring(0, 16));
  const key = CryptoJS.enc.Utf8.parse(code);

  return AES.decrypt(str, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
    .toString(CryptoJS.enc.Utf8)
    .slice(16);
};
export const languageDone = (language) => {
  const { t } = useTranslation();
  if (language === 'EN') {
    return (
      <>
        {' '}
        <Typography variant="h2" className="welcomeTextR">
          {t('Welcome to ', {
            defaultValue: `Welcome to `,
          })}
          <span style={{ color: '#f5821f' }}>
            {t('O', {
              defaultValue: `O`,
            })}
          </span>
          {t('riental', {
            defaultValue: `riental`,
          })}
        </Typography>
      </>
    );
  }
  return (
    <Typography variant="h2" className="welcomeTextR">
      {t('Bienvenido a ', {
        defaultValue: `Bienvenido a `,
      })}
      <span style={{ color: '#f5821f' }}>
        {t('O', {
          defaultValue: `O`,
        })}
      </span>
      {t('riental', {
        defaultValue: `riental`,
      })}
    </Typography>
  );
};

export const handleDOBchangeSaveAppContact = (newValue, context) => {
  const {
    setSaveAppContactScreenDirty,
    setSaveAppContactInfo,
    saveAppContactInfo,
    setBusinessContactInformation,
    setPersonalInformation,
    personalInformation,
    setBusinessAccountInfo,
    businessAccountInfo,
    setSaveAppContactInfoErrors,
    saveAppContactInfoErrors,
    setBusinessAccountInfoError,
    businessAccountInfoError,
    setPersonalInformationErrors,
    personalInformationErrors,
    setBusinessContactInformationErrors,
  } = context;
  setSaveAppContactScreenDirty(true);
  if (newValue) {
    const selectedDate = new Date(newValue);
    const currentdate = new Date();
    const formattedDate = moment(newValue).format('yyyy-MM-DD');

    setSaveAppContactInfo({ ...saveAppContactInfo, dob: formattedDate });
    if (newValue != 'Invalid Date') {
      setBusinessContactInformation((prevState) => ({
        ...prevState,
        dob: formattedDate,
      }));
      setPersonalInformation({ ...personalInformation, dob: formattedDate });
      setBusinessAccountInfo({ ...businessAccountInfo, dob: formattedDate });
    }
    if (newValue == 'Invalid Date') {
      setSaveAppContactInfo({ ...saveAppContactInfo, dob: formattedDate });
      setSaveAppContactInfoErrors({
        ...saveAppContactInfoErrors,
        dob: INVALID_DATE,
      });
      setBusinessAccountInfo({ ...businessAccountInfo, dob: formattedDate });
      setBusinessAccountInfoError({
        ...businessAccountInfoError,
        dob: INVALID_DATE,
      });
    } else if (selectedDate.getTime() > currentdate.getTime()) {
      setSaveAppContactInfoErrors({
        ...saveAppContactInfoErrors,
        dob: INVALID_DATE,
      });
    } else {
      setSaveAppContactInfoErrors({ ...saveAppContactInfoErrors, dob: '' });
      setPersonalInformationErrors({ ...personalInformationErrors, dob: '' });
      setBusinessContactInformationErrors((prevState) => ({
        ...prevState,
        dob: '',
      }));
      setBusinessAccountInfoError({
        ...businessAccountInfoError,
        dob: '',
      });
    }
  } else {
    setSaveAppContactInfo({ ...saveAppContactInfo, dob: '' });
    setSaveAppContactInfoErrors({
      ...saveAppContactInfoErrors,
      dob: MANDATORY_FIELD_ERR,
    });
    setBusinessAccountInfoError({
      ...businessAccountInfoError,
      dob: MANDATORY_FIELD_ERR,
    });
  }
};
export const vouchedJobCallForFraudCheck = async (setIsValidating, leadGenerationContext) => {
  const {
    vouchedJob,
    accessToken,
    setVouchedResponseAddr,
    setPersonalInformation,
    setBusinessAccountInfo,
    setDisableContinue,
    setVouchedFailModal,
    initiateUiResponse,
  } = leadGenerationContext;

  setIsValidating(true);
  const response = await fetchVouchedAddress(vouchedJob, accessToken, initiateUiResponse);
  const vouchedResponse = response?.data?.items?.[0];
  setVouchedResponseAddr(vouchedResponse);
  if (vouchedResponse?.result?.success === false) {
    setIsValidating(false);
    setPersonalInformation((prevState) => ({ ...prevState, uploadSuccessStatus: null }));
    setBusinessAccountInfo((prevState) => ({
      ...prevState,
      uploadSuccessStatus: null,
    }));
    setDisableContinue(true);
    setVouchedFailModal(true);
    const ocrErrorList = [];
    let ocrErrorListinString = '';
    for (const x of vouchedResponse.errors) {
      ocrErrorList.push(x.message);
      ocrErrorListinString = ocrErrorList.join();
    }
    if (leadGenerationContext.productName !== PROGRESA_CONTIGO) {
      await saveKnockOffData(leadGenerationContext, ocrErrorListinString, vouchedJob, '');
    }
  } else {
    setIsValidating(false);
  }
};
export const isPlaidProduct = (prod) =>
  commonTernary(
    productMapping(prod) === ELITE_ACCOUNT_EN ||
      productMapping(prod) === 'Ahorra' ||
      productMapping(prod) === LIBRE_AHORRA_BUNDLE ||
      isIRAProduct(prod) ||
      isABCProduct(prod),
    true,
    false
  );
export const isCDproduct = (prod) =>
  commonTernary(
    productMapping(prod) === PRODUCT_PERSONAL,
    //  || productMapping(prod) === PRODUCT_PERSONALCD
    true,
    false
  );
export const formatDepositAmount = (amount, context) => {
  const { setCdFlowOffers, cdFlowOffers } = context;
  let finalAmount;
  if (amount.endsWith('.00')) {
    const valueWithoutDecimal = amount.slice(0, -3);
    finalAmount = valueWithoutDecimal.replace(/,/g, '');
    setCdFlowOffers({ ...cdFlowOffers, depositAmount: finalAmount });
  } else if (/^\d+$/.test(amount)) {
    finalAmount = amount;
  }
  return finalAmount;
};

export const isKnockOffValueEmployer = async (searchValue) => {
  const list = [
    'Creator Alliance',
    'Creator Alliance LLC',
    'Creator Alliance Puerto Rico',
    'Creators Alliance',
    'Creators Alliance LLC',
    'Creators Alliance Puerto Rico',
    'Creator Aliance',
    'Creator Aliance LLC',
    'Creator Aliance Puerto Rico',
  ];

  return list.some((x) => x.toLowerCase() === searchValue.toLowerCase());
};

export const nbrToCurrencyFormat = (nbr) => nbr?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
export const openNewAccountTab = () => {
  window.open(
    'https://cibng.ibanking-services.com/eAM/Credential/Index?orgId=878_221571415&FIFID=221571415&brand=878_221571415&appId=CeB&FIORG=878',
    '_blank'
  );
};
export const headersData = (customerType, flowTypeETB, customerAppId, accessToken, contentType) => {
  let headers;
  if (customerType === 'ETB' && flowTypeETB === 'EtbFlow') {
    headers = {
      appid: SALES,
      'Application-Id': customerAppId,
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': contentType,
    };
  } else {
    headers = {
      appid: SALES,
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': contentType,
    };
  }
  return headers;
};

// export const openSSPPortal = (otpToken, language) => {
//   localStorage.setItem('sessionData', otpToken);
//   const customAccessToken = otpToken || '';
//   const userType = otpToken ? 'ETB' : 'NTB';
//   console.log({ customAccessToken });
//   console.log({ userType });
// /  console.log(otpToken);

//   // const lang = commonTernary(language === 'EN', 'EN', 'ES');
//   const loginWindow = window.open(
//     `${process.env.REACT_APP_SSP_URL}/?language=${language}&flow=sso&userType=${userType}`,
//     '_blank'
//   );

//   setTimeout(() => {
//     if (loginWindow) {
//       loginWindow.postMessage({ sessionData: customAccessToken }, process.env.REACT_APP_SSP_URL);
//     }
//   }, 5000);
// };

export const isBundle = (product) =>
  commonTernary(productMapping(product) === LIBRE_AHORRA_BUNDLE, true, false);

export const checkMinAge = (result, leadGenerationContext) => {
  let isMinor = false;
  const handleAgeRuleValidation = (message) => {
    if (message && message.length > 0) {
      isMinor = true;
      leadGenerationContext.setPersonalInformationErrors((prevState) => ({
        ...prevState,
        dob: `* ${message}`,
      }));
      const element = getRoot().getElementById(DOB_DAY);
      if (element) {
        element.focus();
      }
    } else {
      isMinor = false;
      leadGenerationContext.setPersonalInformationErrors((prevState) => ({
        ...prevState,
        dob: '',
      }));
    }
  };
  if (result && result.data && result.data.MinAge) {
    if (result.data.MinAge[0]?.message) {
      handleAgeRuleValidation(result.data.MinAge[0].message);
    }
  }
  return isMinor;
};
export const isCDIraproduct = (product) =>
  commonTernary(productMapping(product) === CD_IRA, true, false);

export const formatSSN = (e, ssnObject) => {
  const { selectionStart } = e.target;
  let ssnValue = e.target.value;
  ssnValue = ssnValue?.replace(/\D/g, '');
  if (ssnValue?.toString().length >= 6) {
    ssnValue = `${ssnValue.slice(0, 5)}-${ssnValue.slice(5, ssnValue.toString().length)}`;
  }
  if (ssnValue?.toString().length >= 4) {
    ssnValue = `${ssnValue.slice(0, 3)}-${ssnValue.slice(3, ssnValue.toString().length)}`;
  }

  setTimeout(() => {
    const input = e.target;
    const isAdding = ssnValue.length >= (ssnObject?.ssn?.length || 0);
    if (input?.setSelectionRange) {
      if ((selectionStart === 4 || selectionStart === 7) && isAdding) {
        input.setSelectionRange(selectionStart + 1, selectionStart + 1);
      } else if ((selectionStart === 4 || selectionStart === 7) && !isAdding) {
        input.setSelectionRange(selectionStart - 1, selectionStart - 1);
      } else {
        input.setSelectionRange(selectionStart, selectionStart);
      }
    }
  }, 10);

  return ssnValue;
};

export const formatMaskedSSN = (
  e,
  ssnObject,
  INVALID,
  setErrorstate1,
  setErrorstate2,
  setErrorstate3
) => {
  let { value } = e.target;
  const inputChar = e.nativeEvent?.data;
  const isBackspace = e.nativeEvent?.inputType === 'deleteContentBackward';
  const isDelete = e.nativeEvent?.inputType === 'deleteContentForward';
  let actualSSN = ssnObject?.ssn?.replace(/-/g, '') || '';
  const newSSNArray = actualSSN.split('');

  const startPos = e.target?.selectionStart;
  const maskedBeforeCursor = value.slice(0, startPos);
  const cursorPosInRaw = maskedBeforeCursor.replace(/-/g, '').length;

  if (isBackspace || isDelete) {
    if (cursorPosInRaw >= 0) {
      newSSNArray.splice(cursorPosInRaw, 1);
    }
  } else if (inputChar && /^[0-9]$/.test(inputChar)) {
    newSSNArray.splice(cursorPosInRaw - 1, 0, inputChar);
  } else {
    if (typeof setErrorstate1 === 'function') {
      setErrorstate1((prevState) => ({ ...prevState, ssn: INVALID }));
    }
    if (typeof setErrorstate2 === 'function') {
      setErrorstate2((prevState) => ({ ...prevState, ssn: INVALID }));
    }
    if (typeof setErrorstate3 === 'function') {
      setErrorstate3((prevState) => ({ ...prevState, ssn: INVALID }));
    }
    return typeof value === 'string' ? value : '';
  }

  actualSSN = newSSNArray.join('');
  actualSSN = actualSSN?.replace(/\D/g, '');
  if (actualSSN?.toString().length >= 6) {
    actualSSN = `${actualSSN.slice(0, 5)}-${actualSSN.slice(5, actualSSN.toString().length)}`;
  }
  if (actualSSN?.toString().length >= 4) {
    actualSSN = `${actualSSN.slice(0, 3)}-${actualSSN.slice(3, actualSSN.toString().length)}`;
  }
  e.target.value = actualSSN;
  value = actualSSN;

  setTimeout(() => {
    const input = e.target;
    const isAdding = value.length >= (ssnObject?.ssn?.length || 0);
    if (input?.setSelectionRange) {
      if ((startPos === 4 || startPos === 7) && isAdding) {
        input.setSelectionRange(startPos + 1, startPos + 1);
      } else if ((startPos === 4 || startPos === 7) && !isAdding) {
        input.setSelectionRange(startPos - 1, startPos - 1);
      } else {
        input.setSelectionRange(startPos, startPos);
      }
    }
  }, 10);

  return typeof value === 'string' ? value : '';
};

export const yearCalculatorPR = () => {
  const referenceDate = new Date();
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Puerto_Rico',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  }).formatToParts(referenceDate);

  const getPart = (type) => parts.find((p) => p.type === type)?.value;

  const year = parseInt(getPart('year'), 10);
  const month = parseInt(getPart('month'), 10);
  const day = parseInt(getPart('day'), 10);
  const hour = parseInt(getPart('hour'), 10);
  const minute = parseInt(getPart('minute'), 10);
  const second = parseInt(getPart('second'), 10);
  const currentDateInPR = new Date(year, month - 1, day, hour, minute, second);
  const april15Deadline = new Date(year, 3, 15, 23, 59, 59);
  const october15Deadline = new Date(year, 9, 15, 23, 59, 59);
  const isBtwAprilAndOct15 =
    currentDateInPR >= april15Deadline && currentDateInPR <= october15Deadline;

  return {
    year,
    month,
    day,
    hour,
    minute,
    second,
    currentDateInPR,
    october15Deadline,
    april15Deadline,
    isBtwAprilAndOct15,
  };
};

export const isIRAEducativaProduct = (product) =>
  commonTernary(productMapping(product) === PRODUCT_IRAEDUCATION, true, false);

export const isABCProduct = (product) =>
  commonTernary(productMapping(product) === PRODUCT_ABC, true, false);

export const isIRAProduct = (prod) =>
  commonTernary(
    isCDproduct(prod) || isCDIraproduct(prod) || isIRAEducativaProduct(prod),
    true,
    false
  );

export const isSimilarIRAProducts = (product) =>
  commonTernary(isCDIraproduct(product) || isIRAEducativaProduct(product), true, false);

export const getRoot = () => {
  const host = document.querySelector('sales-express-wc');
  return host?.shadowRoot || document;
};

export const getRequestSource = (context) => {
  let requestSource = '';
  if (context?.testWCFlow || context?.wcFlow) {
    requestSource = context?.requestSource || 'OMB';
  }
  return requestSource;
};

export const getDevicePlatform = (context) => {
  let devicePlatform = '';
  if ((context?.testWCFlow || context?.wcFlow) && context?.isMobileApp) {
    devicePlatform = 'D1 - Mobile';
  } else if ((context?.testWCFlow || context?.wcFlow) && !context?.isMobileApp) {
    devicePlatform = 'D1 - Web';
  }
  return devicePlatform;
};

// Helper: find a Window object that exposes Cordova (current, parent, or top)
export const findCordovaRoot = () => {
  try {
    if (typeof window !== 'undefined' && window.cordova) return window;
  } catch (e) {
    console.log('Accessing window.cordova threw:', e);
  }
  try {
    if (window.parent && window.parent !== window && window.parent.cordova) return window.parent;
  } catch (e) {
    console.log('Accessing window.parent.cordova threw:', e);
  }
  try {
    if (window.top && window.top !== window && window.top.cordova) return window.top;
  } catch (e) {
    console.log('Accessing window.top.cordova threw:', e);
  }
  return null;
};

/**
 * cordovaFileUtils.js
 *
 * Utility to handle Cordova iOS and Android file object incompatibilities.
 *
 * Uses the existing findCordovaRoot() helper already present in the project
 * to detect platformId — same pattern used in saveFileInCordova().
 *
 * NO new platform detection logic — reuses existing codebase pattern:
 *   const root = findCordovaRoot();
 *   const platformId = root?.cordova?.platformId || window.cordova?.platformId;
 */

/**
 * Gets Cordova platformId using the existing findCordovaRoot helper.
 * Exactly matches the pattern used in saveFileInCordova():
 *
 *   const root = findCordovaRoot();
 *   const platformId = root?.cordova?.platformId || window.cordova?.platformId;
 *
 * @returns {string|undefined} 'android' | 'ios' | undefined
 */
export const getCordovaPlatformId = () => {
  const root = findCordovaRoot();
  return root?.cordova?.platformId || window?.cordova?.platformId || 'cordova';
};

export const isCloudPath = (input) => {
  if (typeof input !== 'string') {
    return false;
  }

  const path = input.toLowerCase();

  return [
    'content://',
    'com.google.android.apps.docs',
    'com.microsoft.skydrive',
    'com.dropbox.android',
    'com.box.android',
    'icloud',
    'clouddocs',
    'com.apple.clouddocs',
  ].some((p) => path.includes(p));
};
export const tryFileSystem = (file, hasCordova) =>
  new Promise((resolve, reject) => {
    if (!hasCordova) {
      reject(new Error('cordova-unavailable'));
      return;
    }

    window.resolveLocalFileSystemURL(
      file,
      (entry) => {
        entry.file((nativeFile) => {
          if (nativeFile && nativeFile.size) {
            resolve(nativeFile);
          } else {
            reject(new Error('fs-empty'));
          }
        }, reject);
      },
      reject
    );
  });
export const tryXHR = (file, timeout) =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.open('GET', file, true);
    xhr.responseType = 'arraybuffer';
    xhr.timeout = timeout;

    xhr.onload = () => {
      if (xhr.response && xhr.response.byteLength) {
        resolve(new Blob([xhr.response]));
      } else {
        reject(new Error('xhr-empty'));
      }
    };

    xhr.onerror = () => reject(new Error('xhr-error'));
    xhr.ontimeout = () => reject(new Error('xhr-timeout'));

    xhr.send();
  });
export const tryCopyToCache = (file, hasCordova, timeout) =>
  new Promise((resolve, reject) => {
    if (!hasCordova) {
      reject(new Error('cordova-unavailable'));
      return;
    }

    const timer = setTimeout(() => {
      reject(new Error('copy-timeout'));
    }, timeout);

    const fail = (error) => {
      clearTimeout(timer);
      reject(error);
    };

    const success = (nativeFile) => {
      clearTimeout(timer);

      if (nativeFile && nativeFile.size) {
        resolve(nativeFile);
      } else {
        reject(new Error('copy-empty'));
      }
    };

    const handleCopiedEntry = (copiedEntry) => {
      copiedEntry.file(success, fail);
    };

    const handleCacheDir = (cacheDir, sourceEntry) => {
      const name = sourceEntry.name || 'file';
      const destName = `cloud_${Date.now()}_${name}`;

      sourceEntry.copyTo(cacheDir, destName, handleCopiedEntry, fail);
    };

    const handleSourceEntry = (sourceEntry) => {
      window.resolveLocalFileSystemURL(
        window.cordova.file.cacheDirectory,
        (cacheDir) => handleCacheDir(cacheDir, sourceEntry),
        fail
      );
    };

    window.resolveLocalFileSystemURL(file, handleSourceEntry, fail);
  });
export const resolveFileToBlob = (file) =>
  new Promise((resolve, reject) => {
    if (file instanceof Blob) {
      resolve(file);
      return;
    }

    const TIMEOUT = 60000;
    const errors = [];

    const hasCordova = typeof window !== 'undefined' && window.cordova && window.cordova.file;

    const layers = isCloudPath(file)
      ? [
          () => tryCopyToCache(file, hasCordova, TIMEOUT),
          () => tryFileSystem(file, hasCordova),
          () => tryXHR(file, TIMEOUT),
        ]
      : [
          () => tryFileSystem(file, hasCordova),
          () => tryXHR(file, TIMEOUT),
          () => tryCopyToCache(file, hasCordova, TIMEOUT),
        ];

    const runNext = async (index) => {
      if (index >= layers.length) {
        reject(new Error(`resolveFileToBlob failed:\n${errors.join('\n')}`));
        return;
      }

      const fn = layers[index];

      try {
        const blob = await fn();
        resolve(blob);
      } catch (e) {
        errors.push(`layer-${index}: ${e.message}`);
        runNext(index + 1);
      }
    };

    runNext(0);
  });

// to check whether its cordova in D1
export const isCordovaFn = () => !!window.cordova;

export const getRuntimePlatform = () => {
  if (window.cordova) {
    return window.device?.platform || 'cordova';
  }
  return 'web';
};

export const DOC_TYPES = {
  BIRTH_CERT: 'Date of birth certificate',
  GUARDIANSHIP: 'Proof of guardianship',
  CUSTODIANSHIP: 'Proof of custodianship',
  MINOR: 'Minor',
};

export const isProgresaContigoProduct = (product) => product === PROGRESA_CONTIGO;

export const handleFocusValid = (fieldsValue, fieldsContext) => {
  for (const field of fieldsValue) {
    if (!fieldsContext[field]) {
      const element = document.getElementById(field);
      if (element) {
        element.focus();
        break;
      }
    }
  }
};
export const handlefocus = (fieldsContext, setLoader, fields) => {
  let isElementFound = false;
  for (const field of fields) {
    if (fieldsContext[field]) {
      const element = document.getElementById(field);
      if (element) {
        isElementFound = true;
        element.focus();
        break;
      }
    }
  }
  if (!isElementFound) {
    handleFocusValid(fields, fieldsContext);
  }
  setLoader(false);
};
let emailValid = false;
let emailErrorType = null;
let emailValidationData = null;
const getEmailErrorType = (errorMsg) => {
  const domainErrors = [
    'Email Domain Not Found',
    'Email Server Not Found',
    'Invalid Domain',
    'Unavailable Domain',
  ];
  const mailboxErrors = ['Invalid Email', 'Unknown Email'];
  for (const error of domainErrors) {
    if (error === errorMsg) {
      return 'Domain_Error';
    }
  }
  for (const error of mailboxErrors) {
    if (error === errorMsg) {
      return 'Mailbox_Error';
    }
  }
  return null;
};
const validateEmailResponse = (response, setContextErrorMsg) => {
  if (response && response.status === 200 && response.data[0]) {
    const data = response.data[0];
    if (data.status === 'Valid') {
      emailValid = true;
      setContextErrorMsg((prevState) => ({ ...prevState, emailAdd: '' }));
    } else {
      setContextErrorMsg((prevState) => ({
        ...prevState,
        emailAdd: `* ${data.message}`,
      }));
      emailErrorType = getEmailErrorType(data.message);
    }
    emailValidationData = data;
  }
};
export const emailValidation = async (
  contextErrorMsg,
  contextValue,
  leadGenerationContext,
  setQrCodeValInternalProductError
) => {
  if (
    contextErrorMsg.emailAdd === '* Invalid Format' ||
    contextErrorMsg.emailAdd === '* Invalid Email Domain'
  ) {
    const emailElement = document.getElementById('emailAdd');
    emailElement.setSelectionRange(0, contextValue.emailAdd?.length);
    emailElement.focus();
  } else if (contextValue.emailAdd) {
    console.log({ env: leadGenerationContext?.environment || '' });
    const response = await getEmailVerificationData(
      contextValue.emailAdd,
      leadGenerationContext.accessToken,
      leadGenerationContext.initiateUiResponse,
      {
        isWCFlow: leadGenerationContext?.wcFlow,
        env: leadGenerationContext?.environment || '',
      }
    );
    validateEmailResponse(response, setQrCodeValInternalProductError);
    if (emailErrorType) {
      let emailhighlightStartIndex = 0;
      let emailhighlightEndIndex = 0;
      const emailElement = document.getElementById('emailAdd');
      if (emailErrorType === 'Mailbox_Error') {
        emailhighlightEndIndex = contextValue.emailAdd.indexOf('@');
        emailElement.setSelectionRange(emailhighlightStartIndex, emailhighlightEndIndex);
        emailElement.focus();
      }
      if (emailErrorType === 'Domain_Error') {
        emailhighlightStartIndex = contextValue.emailAdd.indexOf('@') + 1;
        emailhighlightEndIndex = contextValue.emailAdd.length;
        emailElement.setSelectionRange(emailhighlightStartIndex, emailhighlightEndIndex);
        emailElement.focus();
      }
    }
  }
  return {
    valid: emailValid,
    validationData: emailValidationData,
  };
};
export const setSSNError = (context, elementID = '', errMSG = '') => {
  const isBeneficiarySSN = elementID === BENEFICIARY_SSN;
  if (isBeneficiarySSN) {
    context?.setBeneficiaryDataErrors((prevState) => ({
      ...prevState,
      ssn: errMSG,
    }));
  } else {
    context?.setBusinessAccountInfoError((prevState) => ({
      ...prevState,
      ssn: errMSG,
    }));
    context?.setSaveAppContactInfoErrors((prevState) => ({
      ...prevState,
      ssn: errMSG,
    }));
    context?.setPersonalInformationErrors((prevState) => ({
      ...prevState,
      ssn: errMSG,
    }));
    context?.setReturnTosaveAppErrors((prevState) => ({
      ...prevState,
      ssn: errMSG,
    }));
    context?.setPlaidVerificationErrors((prevState) => ({
      ...prevState,
      ssn: errMSG,
    }));
  }
};

export const extractNonUSLocations = (data) => {
  const result = data
    .map(({ Address }) => {
      const addressObject = {
        Address: {
          CountrySubdivisionCode: Address?.CountrySubdivisionCode,
        },
      };
      const country = handleAddressInfo(addressObject);

      // exclude US and VI
      if (!country || country !== 'PR') return null;

      return `${Address.AddressLine1}, ${Address.City}${country === 'PR' ? `, ${country}` : ''}, ${
        Address.PostalCode
      }`;
    })
    .filter(Boolean);

  return result;
};

export const productsNotEligibleForUsAddress = (product) => {
  const productList = [
    'Club',
    'IRA Facil',
    'Annuity IRA',
    'Junior Account',
    'Easy Access',
    'Complete Checking',
    'Oriental Savings',
    'Personal CD',
    'Progresa Contigo',
    'DGI Balanced Fund IRA',
    'DGI Contribution',
    'Ahorro Comercial',
    'CD Comercial',
    'SIN FINES DE LUCRO',
    'ESCROW ACCOUNT',
    'My Biz Account',
    'D Comercial',
    'Prestamo Comercial',
    'Tarjeta de Credito Comercial',
    'Linea de Credito Comercial',
  ];

  return !productList?.includes(
    productMapping(product) || dgiMapping(product) || businessMapping(product)
  );
};

export const getSafeUrl = (location, language, isQR) => {
  try {
    // Validate location against whitelist
    const safeLocation = commonTernary(ALLOWED_LOCATIONS.includes(location), location, null);

    // Validate language against whitelist
    const safeLanguage = commonTernary(
      ALLOWED_LANGUAGES.includes(language),
      language.toLowerCase(),
      null
    );

    // Build URL based on validated values only
    if (isQR) {
      return ORIENTAL_SHAREPOINT_URL;
    }
    if (safeLocation === 'PR' && safeLanguage) {
      return `${BANK_BASE_URL}/${safeLanguage}`;
    }
    if (safeLocation === 'VI' && safeLanguage) {
      return `${BANK_BASE_URL}/${safeLanguage.toLowerCase()}/${safeLocation.toLowerCase()}`;
    }

    return FALLBACK_URL;
  } catch (e) {
    return FALLBACK_URL;
  }
};

export const isSafeUrl = (url) => {
  try {
    const parsed = new URL(url);
    // Only allow https and orientalbank.com domain
    return (
      parsed.protocol === 'https:' &&
      (parsed.hostname === 'orientalbank.com' ||
        parsed.hostname.endsWith('.orientalbank.com') ||
        parsed.hostname === 'orientalbank2016.sharepoint.com')
    );
  } catch (e) {
    return false;
  }
};

export const zipCodeTrimmer = (zipcode) => {
  if (!zipcode) return '';

  const beforeHyphen = zipcode?.split('-')[0];
  const digits = beforeHyphen?.replace(/\D/g, '');

  if (!digits) return '';

  return digits?.padStart(5, '0').slice(0, 5);
};

export const QRCodeinternalProducts = [
  {
    productNameMS: 'Ahorra',
    productNameUI: 'Ahorra Account',
    productType: 'Savings Account',
    productText: 'Ahorra',
  },
  {
    productNameMS: 'Elite Account',
    productNameUI: 'Elite Account',
    productType: 'Checking Account',
    productText: 'Elite',
  },
  {
    productNameMS: 'Libre',
    productNameUI: 'Libre Account',
    productType: 'Checking Account',
    productText: 'Libre',
  },
  {
    productNameMS: 'Libre Account and Ahorra Account',
    productNameUI: 'Libre Account and Ahorra Account',
    productType: 'Checking Account',
    productText: 'Libre+',
  },
];

export const checkSandboxEligibility = (context) => {
  const {
    productName,
    businessContactInformation,
    contactInformation,
    initiateUiResponse,
    inviFlowValues,
    setISVouchedSandbox,
  } = context;
  const currentFirstName = businessMapping(productName)
    ? businessContactInformation?.firstName
    : contactInformation?.firstName;
  const currentLastName = businessMapping(productName)
    ? businessContactInformation?.lastName
    : contactInformation?.lastName;

  const isEligible =
    (initiateUiResponse?.REACT_APP_ENVIRONMENT === 'development' ||
      initiateUiResponse?.REACT_APP_ENVIRONMENT === 'qa') &&
    ((currentFirstName?.toLowerCase() === 'test' && currentLastName?.toLowerCase() === 'pass') ||
      initiateUiResponse?.REACT_APP_VOUCHED_SANDBOX_EMAIL?.some(
        (email) => email?.toLowerCase() === inviFlowValues?.email?.toLowerCase()
      ));
  setISVouchedSandbox((prev) => prev || isEligible);
};

export async function sha256(value) {
  if (!value) return '';

  if (typeof crypto === 'undefined' || !crypto.subtle) {
    console.warn('SubtleCrypto unavailable; skipping hashed tracking');
    return '';
  }

  const encoder = new TextEncoder();
  const data = encoder.encode(value);

  const hashBuffer = await crypto.subtle.digest('SHA-256', data);

  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

export async function getHashedUserData(email, phone, areaCode) {
  const normalizedEmail = email?.trim().toLowerCase() || '';
  const digits = phone?.replace(/\D/g, '') || '';
  const phoneWithoutPlus = `1${areaCode || ''}${digits}`;
  const phoneWithPlus = `+${phoneWithoutPlus}`;

  return {
    hashedEmail: await sha256(normalizedEmail),
    hashedPhone: await sha256(phoneWithoutPlus),
    hashedPhonePlus: await sha256(phoneWithPlus),
  };
}

export const trackingGTM = async (applicationId, email, phone, areaCode) => {
  const { hashedEmail, hashedPhone, hashedPhonePlus } = await getHashedUserData(
    email,
    phone,
    areaCode
  );

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'application_journey',
    applicationId,
    hashedEmail,
    hashedPhone,
    hashedPhonePlus,
  });
};

export const setAutoCompleteFundsError = (value, context) => {
  if (!value) {
    context.setFundDataErrors((prevState) => ({
      ...prevState,
      sourceofFunds: MANDATORY_FIELD_ERR,
    }));
  } else {
    context.setFundDataErrors((prevState) => ({
      ...prevState,
      sourceofFunds: '',
    }));
  }
};

export const toEmptyString = (value) => {
  if (value === null || value === undefined) {
    return '';
  }

  return String(value);
};
export const toZipStringOrEmpty = (value) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const zip = String(value).replace(/\D/g, '');
  return zip;
};
export const getVouchedBarcodeAddressPayload = (barcodeData = {}, country = '') => ({
  Vouched_Address_Line_1: toEmptyString(barcodeData?.streetAddress),
  Vouched_Address_Line_2: toEmptyString(barcodeData?.streetAddress2),
  Vouched_City: toEmptyString(barcodeData?.city),
  Vouched_State: toEmptyString(barcodeData?.state),
  Vouched_Country: toEmptyString(country),
  Vouched_Zip_Code: toZipStringOrEmpty(barcodeData?.postalCode),
});

export const getVouchedEnvForPayload = ({ initiateUiResponse, isVouchedSandbox }) => {
  const currentEnv = initiateUiResponse?.REACT_APP_ENVIRONMENT?.toLowerCase();
  const isDevOrQa = currentEnv === 'development' || currentEnv === 'qa';
  return isDevOrQa && isVouchedSandbox ? 'sandbox' : 'live';
};

export const getMatchingCountries = (list, savedFormAnswer) => {
  const matchingCountries = [];
  Object.keys(savedFormAnswer || {})?.forEach((key) => {
    if (key.includes('TransactionCountry')) {
      const transactionCountries = savedFormAnswer[key];
      transactionCountries.forEach((countryCode) => {
        const matchingCountry = list?.find((country) => country.code === countryCode);
        if (matchingCountry) {
          matchingCountries.push(matchingCountry);
        }
      });
    }
  });
  return matchingCountries;
};

// ─────────────────────────────────────────────────────────────────────────────
// Background-scroll lock for an open Select/Menu.
//
// WHY THIS DOES NOT TOUCH body / documentElement geometry ANYMORE
// ---------------------------------------------------------------
// The previous implementation set `document.body { position:fixed; top; width }`
// and `document.documentElement { overflow:hidden }`. That mutates GLOBAL page
// geometry. When CustomSelect runs inside our Web Component embedded in an
// external host application, the host's own document is the real scroller.
// Forcing `position:fixed` on the host <body> removes it from normal flow and
// collapses its height context, which is what produced the large blank white
// space below the host page.
//
// Only iOS Cordova/WebKit actually needs a JS lock: it ignores `overflow:hidden`
// and keeps rubber-band / background scrolling on touchmove. Desktop React,
// Android and the normal Web Component flow already stop background scroll on
// their own (after the `overflow:auto !important` override was removed), so for
// them we intentionally do NOTHING — that keeps their behavior identical and
// eliminates the host-layout regression.
//
// On iOS Cordova we intercept `touchmove` at the document level (non-passive)
// and preventDefault for any touch that is NOT inside the currently open menu
// list. `composedPath()` is used so detection works across the Shadow DOM
// boundary (a document-level listener would otherwise only see the shadow host
// due to event retargeting). Touches inside the menu are allowed to scroll, with
// a boundary guard so the scroll never chains/bounces into the background.
//
// The (touchGuardRef) signature is preserved
// so every existing call site remains unchanged. `bodyStylesRef` now stores the
// active touch guard so unlockScroll can detach the exact same listeners.
// ─────────────────────────────────────────────────────────────────────────────

const isIosCordovaWebView = () => {
  const root = findCordovaRoot();
  const platformId = root?.cordova?.platformId || window?.cordova?.platformId;
  return platformId === 'ios';
};

const MENU_SCROLL_SELECTOR = '.MuiMenu-list, .MuiList-root';
const MENU_CONTAINER_SELECTOR = '.MuiMenu-list, .MuiList-root, .MuiMenu-paper, .MuiPaper-root';

// Walk the composed event path (Shadow-DOM safe) and return the open menu
// element the touch happened inside, or null if the touch is on the background.
const findMenuInPath = (path) => {
  for (let i = 0; i < path.length; i += 1) {
    const el = path[i];
    if (el === document || el === window) break;
    if (el && el.nodeType === 1 && typeof el.matches === 'function') {
      if (el.matches(MENU_CONTAINER_SELECTOR)) return el;
    }
  }
  return null;
};

const createTouchGuard = () => {
  let startY = 0;

  const onTouchStart = (e) => {
    startY = e.touches && e.touches.length ? e.touches[0].clientY : 0;
  };

  const onTouchMove = (e) => {
    // Leave pinch-zoom and non-cancelable events to native handling.
    if (!e.cancelable || (e.touches && e.touches.length > 1)) return;

    const path = typeof e.composedPath === 'function' ? e.composedPath() : [];
    const menu = findMenuInPath(path);

    if (!menu) {
      // Background touch → block it. This is what stops iOS WebKit rubber-band
      // / background scrolling without mutating any layout geometry.
      e.preventDefault();
      return;
    }

    // Touch is inside the menu: allow internal scrolling but stop it chaining
    // to the background at the boundaries.
    const scroller = menu.matches(MENU_SCROLL_SELECTOR)
      ? menu
      : menu.querySelector(MENU_SCROLL_SELECTOR) || menu;

    const { scrollTop, scrollHeight, clientHeight } = scroller;
    const currentY = e.touches && e.touches.length ? e.touches[0].clientY : startY;
    const deltaY = currentY - startY;

    const noOverflow = scrollHeight <= clientHeight;
    const atTop = scrollTop <= 0;
    const atBottom = scrollTop + clientHeight >= scrollHeight;

    if (noOverflow || (atTop && deltaY > 0) || (atBottom && deltaY < 0)) {
      e.preventDefault();
    }
  };

  return { onTouchStart, onTouchMove };
};

export const lockScroll = (touchGuardRef) => {
  // Non iOS-Cordova targets already prevent background scroll natively → no-op.
  if (!isIosCordovaWebView()) return;

  // Idempotency: never attach the listeners twice.
  if (touchGuardRef.current && touchGuardRef.current.guard) {
    unlockScroll(touchGuardRef);
  }

  const guard = createTouchGuard();
  document.addEventListener('touchstart', guard.onTouchStart, { passive: true, capture: true });
  document.addEventListener('touchmove', guard.onTouchMove, { passive: false, capture: true });

  // eslint-disable-next-line no-param-reassign
  touchGuardRef.current = { guard };
};

export const unlockScroll = (touchGuardRef) => {
  const stored = touchGuardRef.current;
  if (stored && stored.guard) {
    document.removeEventListener('touchstart', stored.guard.onTouchStart, { capture: true });
    document.removeEventListener('touchmove', stored.guard.onTouchMove, { capture: true });
  }
  // eslint-disable-next-line no-param-reassign
  touchGuardRef.current = null;
};
